/**
 * Splits a marketing page's body before its nth second-level heading (1-based), so a template can
 * place other sections between the two parts. The same split is made on the Markdown (a page reached
 * by in-app navigation) and on the HTML the build rendered from it (a page served as static HTML):
 * `## ` lines become top-level `<h2>` elements, so both splits fall at the same place and the two HTML
 * parts put back together are the whole body again (marketingPageMarkdownCache.ts relies on that).
 * A body with fewer headings is returned whole, with an empty second part.
 */
export function splitMarkdownBeforeHeading(markdown: string, headingNumber: number): [string, string] {
  let headingsSeen = 0;
  for (const match of markdown.matchAll(/^## /gm)) {
    headingsSeen += 1;
    if (headingsSeen === headingNumber) return [markdown.slice(0, match.index), markdown.slice(match.index)];
  }
  return [markdown, ""];
}

export function splitRenderedHtmlBeforeHeading(renderedHtml: string, headingNumber: number): [string, string] {
  let headingsSeen = 0;
  for (const match of renderedHtml.matchAll(/<h2[\s>]/g)) {
    headingsSeen += 1;
    if (headingsSeen === headingNumber) return [renderedHtml.slice(0, match.index), renderedHtml.slice(match.index)];
  }
  return [renderedHtml, ""];
}
